import React , {useContext} from 'react';
import "./coupons.css";
import Lottie from "lottie-react";
import discountLottie from "../../../../assets/lottie/discount.json";
import CartContext from '../../../../context/cart_context'


const ValidCoupon = ({setShowValidCoupon ,selectedCoupon }) => {
  
  const {couponAmount}  = useContext(CartContext);   

 return (
    <div className= 'valid-coupon-bg' >
        <div className='valid-coupon-container'>
        <Lottie animationData={discountLottie} className="discount-lottie"   />
            <p>You have sucessfully applied coupon code</p>
            <h4>{selectedCoupon.couponCode}</h4>
            <h3>{"\u{20B9}\t"}{couponAmount}</h3>
            <span>saved with this coupon</span>
            <button onClick={() => setShowValidCoupon(false)} >Continue</button>
        </div>
    </div>
  )
}

export default ValidCoupon